import { useState, useEffect } from "react";
import { useI18n } from "@/i18n/I18nProvider";
import Box from "@mui/material/Box";
import { colors } from "../../utils/const";

export default function Navigation_Bar() {
  const { t, locale } = useI18n();
  

  const [sectionProgress, setSectionProgress] = useState({});
  const [bgFill, setBgFill] = useState({});

  useEffect(() => {
    const handleScroll = () => {
      let sections = document.querySelectorAll("[data-section]");
      let progressMap = {};
      let newBgFill = {};
      let activeSectionId = "";
      let prevFilled = 100;

      sections.forEach((section, index) => {
        const rect = section.getBoundingClientRect();
        const sectionId = section.getAttribute("id");

        const sectionHeight = rect.height;
        const viewportHeight = window.innerHeight;

        let progress = Math.max(
          0,
          Math.min(1, (viewportHeight - rect.top) / sectionHeight)
        );

        progress = Math.max(0, Math.min(progress, 1));
        progressMap[sectionId] = progress;

        if (
          rect.top < viewportHeight * 0.6 &&
          rect.bottom > viewportHeight * 0.4
        ) {
          let fillPercent = Math.min(
            100,
            ((viewportHeight - rect.top) /
              (viewportHeight + section.offsetHeight)) *
              100
          );

          if (index === 0 || prevFilled === 100) {
            newBgFill[sectionId] = fillPercent;
            activeSectionId = sectionId;
            prevFilled = fillPercent >= 99 ? 100 : fillPercent;
          } else {
            newBgFill[sectionId] = 0;
          }
        } else {
          newBgFill[sectionId] = 0;
        }
      });

      setSectionProgress(progressMap);
      setBgFill(newBgFill);
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  return (
    <Box
      sx={{
        width: "100%",
        position: "fixed",
        display: { xs: "none", lg: "flex" },
        bottom: "0",
        zIndex: "1000",
        marginBottom: "10px",
        borderRadius: "12px",
        height: "90px",
      }}
    >
      <Box
        sx={{
          background: "rgba(255, 255, 255, 0.6)",
          backdropFilter: "blur(10px)",
          borderRadius: "12px",
          padding: "30px 8px",
          display: "flex",
          flexDirection: { xs: "column", lg: "row" },
          alignItems: "center",
          gap: "12px",
          // width: { lg: "100%", xl: "75%" },
          width: { lg: "70%", xl: "55%" },
          margin: "0 auto",
        }}
      >
        {/* Logo Section */}
        {/* <Box
        sx={{
          backgroundColor: colors.white,
          padding: "16px 12px",
          borderRadius: "12px",
          height: "75px",
          display: "flex",
          alignItems: "center",
        }}
      >
        <Link href="/">
          <Box
            component="img"
            src={t.logo}
            alt="Picture of the author"
            loading="lazy"
            sx={{ width: { xs: "60px", sm: "80px", md: "100px" } }}
          />
        </Link>
      </Box> */}

        {/* Navigation Links */}
        <Box
          sx={{
            display: "flex",
            flexDirection: { xs: "column", lg: "row" },
            alignItems: "center",
            gap: "12px",
            flex: "1",
            background: colors.white,
            borderRadius: "16px",
            height: "70px",
            padding: "10px 8px",
          }}
        >
          {t.pages_main_tags.whyContact.navigation_bar.sections.map(
            (section) => {
              const sectionId = section.href.replace("#", "");
              const progress = sectionProgress[sectionId] || 0;
              const filledPercentage = bgFill[sectionId] || 0;

              return (
                <Box
                  key={section.id}
                  sx={{
                    flex: "1 1 auto",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    padding: "12px 0",
                    borderRadius: "12px",
                    border:
                      filledPercentage > 30
                        ? `1px solid ${colors.orange}`
                        : `1px solid ${colors.baby_black}`,
                    transition: "all 0.3s ease",
                    background:
                      locale === "ar"
                        ? `linear-gradient(to left, ${colors.orange} ${filledPercentage}%, white ${filledPercentage}%)`
                        : `linear-gradient(to right, ${colors.orange} ${filledPercentage}%, white ${filledPercentage}%)`,
                  }}
                >
                  <a
                    style={{
                      textDecoration: "none",
                      cursor: "pointer",
                      color: colors.baby_black,
                      transition: "all 0.3s ease",
                      whiteSpace: "nowrap",
                      fontSize:"15px"
                    }}
                    onClick={(e) => {
                      e.preventDefault();
                      document
                        .getElementById(sectionId)
                        .scrollIntoView({ behavior: "smooth" });
                      setBgFill({});
                    }}
                  >
                    {section.title}
                  </a>
                </Box>
              );
            }
          )}
        </Box>

        {/* Contact Us Section */}
        {/* <Box
        sx={{
          backgroundColor: colors.white,
          padding: "16px 12px",
          borderRadius: "12px",
          height: "75px",
          display: "flex",
          alignItems: "center",
        }}
      >
        <Link
          href="/contact-us"
          style={{
            color: "black",
            textDecoration: "none",
          }}
        >
          <Box
            sx={{
              fontWeight: "700",
              fontSize: { xs: "14px", md: "16px" },
              borderRadius: "8px",
              padding: "8px 12px",
            }}
          >
            {t.pages_main_tags.whyContact.navigation_bar.contact_us}
          </Box>
        </Link>
      </Box> */}
      </Box>
    </Box>
  );
}
